import { render, staticRenderFns } from "./RichContent.vue?vue&type=template&id=05b91cb1"
import script from "./RichContent.vue?vue&type=script&lang=js"
export * from "./RichContent.vue?vue&type=script&lang=js"
import style0 from "./styles/rich-content.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports